import React from 'react';
import { IonBackButton, IonButtons, IonCard, IonContent, IonFooter, IonHeader, IonItem, IonLabel, IonList, IonNote, IonPage, IonToolbar, withIonLifeCycle } from '@ionic/react';

//	L O C A L E

import { locale___App } from '../../../App.locale';
import { locale___SbDigitalMenuEditAppearancePage } from './sb-digitalmenu-edit-appearance.locale';

//	S T Y L E

import './sb-digitalmenu-edit-appearance.scss';

//	S T A T E   -   P R O P S

import { props___SbDigitalMenuEditAppearancePage, state___SbDigitalMenuEditAppearancePage, state___SbDigitalMenuEditAppearancePage___default } from './sb-digitalmenu-edit-appearance.state';

//	T Y P E S

import { type___api___response } from '../../../types/types.api-response';
import { type___digitalmenu___theme } from '../../../types/types.theme';

//	S E R V I C E S

import { service_RestApiService } from '../../../services/service-api';
import { service_Router } from '../../../services/service-router';
import { service_LocalizationService } from '../../../services/service-localization';

//	C O M P O N E N T S

import Com404Component from '../../../components/com-404/com-404';
import ComDigitalMenuPreviewComponent from '../../../components/com-digitalmenu-preview/com-digitalmenu-preview';
import ComSpinnerInlineComponent from '../../../components/com-spinner-inline/com-spinner-inline';

//	C L A S S

class SbDigitalMenuEditAppearancePage extends React.Component<props___SbDigitalMenuEditAppearancePage, state___SbDigitalMenuEditAppearancePage> {

//#region 																							D E C L A R A T I O N S

	private readonly _API: service_RestApiService = new service_RestApiService();
	private readonly _ROUTER: service_Router = new service_Router();
	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___SbDigitalMenuEditAppearancePage,
	) {
		super(props);
		this.state = state___SbDigitalMenuEditAppearancePage___default;
	}

//#endregion

//#region 																							R E A D   P R O P S

	private read_props___digitalmenu = async () => {
		const ___temp___poi___props: type___api___response = await this._API.digitalmenus___read_single(this.state.digitalmenu___id);
		if (!___temp___poi___props || ___temp___poi___props.response !== 'success' || ___temp___poi___props.data === null) { console.log('404'); }
		this.setState({
			digitalmenu___props: ___temp___poi___props.data,
			digitalmenu___props___isLoading: false,
		}, () => {
			this.setState({
				theme___props: this.state.digitalmenu___props['digitalmenu_theme']
			}, () => {
				this.handle___change_theme_value(null, null);
			})
		});
	}

//#endregion

//#region 																							H A N D L E R S

	private handle___change_theme_value = (___key: string | null, ___value: string | null) => {
		const ___theme: type___digitalmenu___theme = this.state.theme___props;
		if (___key && ___key !== null && ___value && ___value !== null) { ___theme[___key] = ___value; }
		this.setState({
			theme___props: ___theme,
		}, () => { 
			document.documentElement.style.setProperty('--digitalmenu-preview---theme---color---background', this.state.theme___props.color___background);
			document.documentElement.style.setProperty('--digitalmenu-preview---theme---color---foreground', this.state.theme___props.color___foreground);
			document.documentElement.style.setProperty('--digitalmenu-preview---theme---color---accent', this.state.theme___props.color___accent);
			document.documentElement.style.setProperty('--digitalmenu-preview---theme---appearance---shadow', this.state.theme___props.appearance___shadow);
			document.documentElement.style.setProperty('--digitalmenu-preview---theme---appearance---font-family', this.state.theme___props.appearance___font_family);
			document.documentElement.style.setProperty('--digitalmenu-preview---theme---appearance---border-radius', (this.state.theme___props.appearance___border_radius.toString() + 'pt'));
		});
	}

	private handle___submit___theme = async () => {
		const ___theme_updated: type___api___response = await this._API.digitalmenu___set_theme(this.state.digitalmenu___id, this.state.theme___props);

		


	}

//#endregion

//#region 																							L I F E C Y C L E

	ionViewDidEnter() : void {
		const ___digitalmenu_id: string | null = this._ROUTER.get_id(this.props);
		this.setState({
			digitalmenu___id: (___digitalmenu_id !== 'new') ? ___digitalmenu_id : null,
		}, async () => {
			if (this.state.digitalmenu___id !== null) {
				await this.read_props___digitalmenu();
			} else {
				this.setState({
					digitalmenu___props___isLoading: false
				})
			}
		});
	}

//#endregion

//#region 																							R E T U R N

	render() : React.ReactNode {
		return <>
			<IonPage>

				<IonHeader>
					<IonToolbar>
						<IonButtons slot="start">
							<IonBackButton defaultHref="/digitalmenu/list" text={ this._LOCALE.translate(locale___App.ionBackButton___text) }></IonBackButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>

				<IonContent forceOverscroll={ false }>
					{(this.state.digitalmenu___props___isLoading === true) ? <>

						<br />
						<br />
						<br />
						<br />
						<br />
						<br />

						<ComSpinnerInlineComponent />

					</> : <>

						{(this.state.digitalmenu___props !== null) ? <>
							<section className="sb-digitalmenu-edit-appearance---container">

								<ComDigitalMenuPreviewComponent theme_props={this.state.theme___props}/>

								<br />

								<IonCard>
									<IonList>
										<IonItem>
											<IonLabel>Colore di Sfondo</IonLabel>
											<IonNote slot="end">
												<input type="color" value={this.state.theme___props.color___background} onChange={(___e: any) => { this.handle___change_theme_value('color___background', ___e.target.value); }}/>
											</IonNote>
										</IonItem>
										<IonItem>
											<IonLabel>Colore del Testo</IonLabel>
											<IonNote slot="end">
												<input type="color" value={this.state.theme___props.color___foreground} onChange={(___e: any) => { this.handle___change_theme_value('color___foreground', ___e.target.value); }}/>
											</IonNote>
										</IonItem>
										<IonItem>
											<IonLabel>Colore dei Dettagli</IonLabel>
											<IonNote slot="end">
												<input type="color" value={this.state.theme___props.color___accent} onChange={(___e: any) => { this.handle___change_theme_value('color___accent', ___e.target.value); }}/>
											</IonNote>
										</IonItem>
									</IonList>
								</IonCard>

							</section>
						</> : <>
							<Com404Component/>
						</>}

						<br />
						<br />
						<br />

					</>}
				</IonContent>

				<IonFooter>
					<section className="container---footer-section" onClick={ this.handle___submit___theme }>
						<button className="is-element is-button is-color---folly is-full-width">
							<i className="fa-solid fa-check"></i>
							<h6>Salva Tema</h6>
						</button>
					</section>
				</IonFooter>

			</IonPage>
		</>;
	}

//#endregion

}

//	E X P O R T

export default withIonLifeCycle(SbDigitalMenuEditAppearancePage);